export default __webpack_public_path__ + "static/Logo-bigjerrysfencing-e9e5c5ea24fa93bd210966503f539fdb.png";